define('home/views/ForumCardView',[
    'underscore',
    'backbone-marionette',
    'home/utils/confirmModal',

    'home/mixins/withChannelAvatar',
    'home/models/Session',
    'home/templates/forumCard',
    'home/templates/confirmResignModerator',
], function (
    _,
    Marionette,
    confirmModal,

    withChannelAvatar,
    Session,
    forumCardTemplate,
    confirmResignModeratorTemplate
) {
    'use strict';

    /**
     * A card that shows a forum or channel. Shows the avatar, title, description,
     * following status, and follow action.
     *
     * Expects a forum model.
     */
    var ForumCardView = Marionette.ItemView.extend({
        template: forumCardTemplate,
        templateHelpers: function () {
            var channel = this.model.channel;

            return {
                sessionUserIsOwner: this.sessionUserIsOwner,
                sessionUserIsModerator: this.sessionUserIsModerator,
                channelDescription: channel && channel.get('options').description,
            };
        },
        className: 'card',

        events: {
            'click [data-action=toggle-follow]': 'toggleFollow',
            'click [data-action=remove-moderator]': 'confirmRemoveModerator',
        },
        modelEvents: {
            'change:isFollowing': 'handleFollowedClass',
        },

        initialize: function () {
            this.session = Session.get();

            // Once session has loaded, show a creator badge if session user is the owner
            // of this forum/channel
            this.session.loadPromise().then(_.bind(this.renderIfOwner, this));

            // Once session has loaded the forums the user moderates, show a mod badge if session
            // user moderates this forum/channel
            this.session.loadModeratedForums().then(_.bind(this.renderModeratorStatus, this));
        },

        renderIfOwner: function () {
            var ownerId = this.model.channel && this.model.channel.get('owner_id');
            var sessionUserId = this.session.user.get('id');
            this.sessionUserIsOwner = ownerId === sessionUserId;

            if (this.sessionUserIsOwner)
                this.render();
        },

        /**
         * Determines if the session user is a moderator. Rerenders this card if the moderator
         * status has changed.
         * ex: rendered before fetch completed to determine user is a moderator.
         * ex: user resigned as a moderator.
         */
        renderModeratorStatus: function () {
            var wasSessionUserModerator = Boolean(this.sessionUserIsModerator);
            var sessionUserModeratedForums = this.session.user.get('moderatedForums');
            this.sessionUserIsModerator = _.contains(sessionUserModeratedForums, this.model.get('id'));

            if (wasSessionUserModerator !== this.sessionUserIsModerator)
                this.render();
        },

        handleFollowedClass: function () {
            this.$('[data-action=toggle-follow]').toggleClass('active', this.model.get('isFollowing'));
        },

        toggleFollow: function (evt) {
            if (evt)
                evt.preventDefault();

            this.model.toggleFollowed();
        },

        confirmRemoveModerator: function (evt) {
            if (evt)
                evt.preventDefault();

            var channel = this.model.channel;

            confirmModal.confirmationPromise(
                confirmModal.TYPES.CONFIRM_CANCEL,
                confirmResignModeratorTemplate(channel.toJSON())
            ).then(_.bind(function (isConfirmed) {
                if (!isConfirmed)
                    return;

                // After user has resigned as moderator, rerender card to remove
                // the moderator tag and the resign button
                this.session.user.moderateChannel(channel, false)
                    .then(_.bind(this.renderModeratorStatus, this));
            }, this));
        },
    });

    withChannelAvatar.call(ForumCardView.prototype, function () {
        return this.model.channel;
    });

    return ForumCardView;
});

